import axios from 'axios';
import config from '../config';
import { normaliseCatalogue } from '../lib/catalogue';

/**
 * Loads the shop's catalogue from the middleware's public price list and normalises it
 * (plugin licence plans and plugin credit packs only — the NXT world is sold in the
 * webclient). Throws on a network / server failure so the page can show an error.
 */
export const catalogueService = {
  fetchCatalogue: async () => {
    const response = await axios.get(config.catalogueUrl, { timeout: 15000, headers: { Accept: 'application/json' } });
    return normaliseCatalogue(response.data);
  },
};
